define.alias("shared/errors/media-library", "settings/errors/media-library");